import { useMemo } from 'react'
import { Group } from '@wellesley/openapi'
import useGroupMember from '../useGroupMember'
import useGroupPermissions from '../useGroupPermissions'
import { isOwner } from '../../helpers/userRole'
import { GroupActionConfig } from '../../types/group-actions'

const useGroupActions = (group: Group, actionConfigs: GroupActionConfig[]) => {
  const { groupMember: membership } = useGroupMember(group.groupId)
  const permissions = useGroupPermissions(group.groupId)

  const isGroupOwner = isOwner(membership)
  const isMember = membership?.state === 'MEMBER'

  const actions = useMemo(
    () =>
      actionConfigs
        .filter(({ shouldShow }) =>
          shouldShow({ permissions, isOwner: isGroupOwner, isMember }),
        )
        .map(({ action }) => action),
    [actionConfigs, permissions, isGroupOwner, isMember],
  )

  return {
    actions,
    membership,
    permissions,
    isGroupOwner,
    isMember,
  }
}

export default useGroupActions
